/**
 * AI Document Assistant Admin Page
 * 
 * Quản lý Collections, Documents và Analytics cho File Search RAG System
 */

import React, { useState } from 'react';
import { Tabs, Card } from 'antd';
import { FolderOutlined, FileTextOutlined, BarChartOutlined } from '@ant-design/icons';
import CollectionsTab from '../../components/AIAssistant/CollectionsTab';
import DocumentsTab from '../../components/AIAssistant/DocumentsTab';
import AnalyticsTab from '../../components/AIAssistant/AnalyticsTab';

const AIAssistantAdmin: React.FC = () => {
  const [activeTab, setActiveTab] = useState('collections');

  const items = [
    {
      key: 'collections',
      label: (
        <span>
          <FolderOutlined />
          Bộ sưu tập
        </span>
      ),
      children: <CollectionsTab />,
    },
    {
      key: 'documents',
      label: (
        <span>
          <FileTextOutlined />
          Tài liệu
        </span>
      ),
      children: <DocumentsTab />,
    },
    {
      key: 'analytics',
      label: (
        <span>
          <BarChartOutlined />
          Phân tích
        </span>
      ),
      children: <AnalyticsTab />,
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Card title="Quản lý Cố vấn học tập AI" bordered={false}>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          size="large"
        />
      </Card>
    </div>
  );
};

export default AIAssistantAdmin;
